<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <MerchantWalletFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('walletRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchTransaction"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="walletRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loading="setLoading(true)"
          @loaded="onLoaded"
        >
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
          <template slot="type" slot-scope="{ row }">
            {{ titleCase(row.type) }}
          </template>
          <template slot="source" slot-scope="{ row }">
            {{ titleCase(row.source) }}
          </template>
          <div slot="status" slot-scope="{ row }">
            <span
              class="badge badge-app"
              :class="
                row.status === 'successful' ? 'badge-success' : 'badge-danger'
              "
            >
              {{ row.status }}
            </span>
          </div>
          <div slot="action" slot-scope="{ row }">
            <span class="badge badge-app">
              {{ row.action === "credit" ? "Credit" : "Debit" }} </span
            ><span
              ><img
                v-if="row.action === 'credit'"
                src="/assets/img/icons/import.svg"
                alt=""
              />
              <img v-else src="/assets/img/icons/export.svg" alt="" />
            </span>
          </div>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../../components/utils/TableWrapper/TableWrapper.vue";
import MerchantWalletFilter from "../../../../../../components/filters/MerchantWalletFilter.vue";

const tableHeadings = {
  account_name: "Account Name",
  account_number: "Account Number",
  bank_name: "Bank Name",
  wallet_id: "Wallet Id",
  "Customer.reference": "Reference",
  createdAt: "Date Created",
};

export default {
  name: "Wallet",
  mixins: [componentData],
  data() {
    return {
      singleTransactionObj: null,
      showTransactionModal: false,
      emptyTitle: "No Wallet Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(tableHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    MerchantWalletFilter,
  },
  methods: {
    toggleTransactionModal() {
      this.showTransactionModal = !this.showTransactionModal;
    },
    refetch(filters) {
      let newFilters = { ...filters };
      if (newFilters.status) newFilters.status = newFilters.status.value;
      this.handleRefetch(newFilters, this.fetchTransaction, "walletRef");
    },
    async fetchTransaction() {
      this.options.requestFunction = async (data) => {
        const params = {
          ...data,
          ...this.filters,
          id: this.$route.params.clientid,
          customer: this.$route.params.customerid,
        };
        const response = await this.$store.dispatch(
          "payment/getCustomerWallet",
          {
            params,
          }
        );

        const newData = response.data.customerWallets.data;
        const count = response.data.customerWallets.count;
        return { ...response, count, total: count, data: newData };
      };
    },
  },

  created() {
    this.fetchTransaction();
  },
  mounted() {
    this.columns = Object.keys(tableHeadings).map((keyVal) => keyVal);
  },
};
</script>
